import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useLocale } from '../../context';
import { useBottomSheetGestures } from '../../hooks/useBottomSheetGestures';
import { lockScroll, unlockScroll } from '../../scrollLock';

export default function AuthCodeHelpSheet({ open, onClose, contactType = 'phone' }) {
  const _locale = useLocale();
  const tr = _locale.t;
  const {
    sheetRef,
    scrollRef,
    overlayStyle,
    dragging,
    dragHandlers,
  } = useBottomSheetGestures({
    open,
    onClose,
    dismissEnabled: true,
    handleOnly: true,
  });

  useEffect(() => {
    if (!open) return undefined;
    lockScroll();
    return () => unlockScroll();
  }, [open]);

  if (!open) return null;

  const isEmail = contactType === 'email';

  return createPortal(
    <div
      className="auth-code-help-sheet__overlay is-open"
      style={overlayStyle}
      onClick={onClose}
      role="presentation"
    >
      <div
        id="bottomSheet"
        ref={sheetRef}
        className={`auth-code-help-sheet${dragging ? ' is-dragging' : ''} is-visible`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="auth-code-help-title"
        {...dragHandlers}
      >
        <div className="auth-code-help-sheet__thumb" aria-hidden="true" />
        <div className="auth-code-help-sheet__body" ref={scrollRef}>
          <div className="auth-code-help-sheet__container">
            <h2 id="auth-code-help-title" className="auth-code-help-sheet__title">
              {tr('auth.verify.help.title')}
            </h2>
            <p className="auth-code-help-sheet__text">
              {isEmail
                ? tr('auth.verify.help.bodyEmail')
                : tr('auth.verify.help.bodyPhone')}
            </p>
            {!isEmail && (
              <ol className="auth-code-help-sheet__steps">
                <li>{tr('auth.verify.help.step1')}</li>
                <li>{tr('auth.verify.help.step2')}</li>
                <li>{tr('auth.verify.help.step3')}</li>
              </ol>
            )}
            <button type="button" className="auth-submit auth-code-help-sheet__button" onClick={onClose}>
              {tr('auth.verify.help.understood')}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
}
